import React from 'react'
import { useParams } from 'react-router-dom'
import CreatePuzzle from './CreatePuzzle'

// For now, EditPuzzle just renders CreatePuzzle
// In a full implementation, it would load existing puzzle data
export default function EditPuzzle() {
  const { id } = useParams()

  // TODO: Load existing puzzle data and pass to CreatePuzzle
  return <CreatePuzzle puzzleId={id} />
}
